import React from "react";
import { Link } from "react-router-dom";
import Icon from "./ui/Icon";

export default class RouteErrorBoundary extends React.Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidUpdate(previousProps) {
    if (this.state.hasError && previousProps.pathname !== this.props.pathname) {
      this.setState({ hasError: false });
    }
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div className="ui-page ui-empty-page ui-route-error" role="alert">
        <Icon name="refresh" size={36} />
        <h1>This page couldn’t open.</h1>
        <p>
          The connection may have dropped, or the workspace may have been updated.
          Reload this page to try again.
        </p>
        <div className="ui-route-error-actions">
          <button
            type="button"
            className="ui-button ui-button--primary"
            onClick={() => window.location.reload()}
          >
            Reload page <Icon name="refresh" />
          </button>
          <Link className="ui-button ui-button--secondary" to="/">
            Back to overview <Icon name="arrow" />
          </Link>
        </div>
      </div>
    );
  }
}
